"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disable = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Disable = function Disable() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM21.6 12C21.6026 14.1319 20.8884 16.2029 19.572 17.88L6.11998 4.42795C7.79704 3.11157 9.868 2.3973 12 2.39995C14.5461 2.39995 16.9879 3.41138 18.7882 5.21173C20.5886 7.01208 21.6 9.45388 21.6 12ZM4.42795 6.12012C3.11157 7.79717 2.3973 9.86813 2.39995 12.0001C2.39995 14.5462 3.41138 16.988 5.21173 18.7883C7.01208 20.5887 9.45388 21.6001 12 21.6001C14.1319 21.6028 16.2029 20.8885 17.88 19.5721L4.42795 6.12012Z"
  });
};

exports.Disable = Disable;